import { Box, styled, Typography, TypographyProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { forwardRef } from 'react';

import { Icon } from '@/components/Icon';
import { Drawer, DrawerProps } from '@/components/Layout/Drawer';

export const ReviewPersonalInfoDrawerStyled = styled((props: DrawerProps) => (
  <Drawer
    {...props}
    headerBgColor={(theme: Theme) => theme.palette.neutral[100]}
  />
))(({ theme }) => ({
  '.MuiDrawer-paper': {
    backgroundColor: theme.palette.neutral[100],
    [theme.breakpoints.up('xl')]: {
      '.DrawerContent': {
        paddingTop: '0px',
      },
    },
  },
}));

export const EmploymentInfoReviewDocumentIcon = styled(Icon)(({ theme }) => ({
  backgroundColor: theme.palette.primaries[200],
  padding: theme.spacing(1),
  border: `16px solid ${theme.palette.neutral.min}`,
  borderRadius: '50%',
  color: theme.palette.primaries[400],
}));

export const EmploymentInfoReviewFieldLabel = styled(
  (props: TypographyProps) => <Typography className="caption" {...props} />,
)(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: theme.palette.neutral[700],
}));

export const EmploymentInfoReviewFieldValue = styled(
  (props: TypographyProps) => <Typography className="body2Medium" {...props} />,
)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
}));

export const ReviewEmploymentInfoDetailCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral[100],
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
}));

export const ReviewEmploymentInfoDrawerContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(2),
}));

export const ReviewEmploymentInfoDrawerHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral.min,
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  padding: theme.spacing(2),
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(2),
  width: '100%',

  '.MuiButton-root': {
    display: 'block',
    margin: `0 auto`,
  },
}));

export const StyledReviewEmploymentInfoDrawer = styled(
  forwardRef<HTMLDivElement, DrawerProps>((props, ref) => (
    <Drawer ref={ref} slotProps={{}} {...props} />
  )),
)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.neutral.min,
  },
}));

export const UploadedDocumentItem = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral.min,
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  paddingRight: theme.spacing(2),
}));
